/**
 * Notifier class.
 *
 * @constructor
 */
const Notifier = function () {

    this.notificationsList = document.getElementById('notifications');

    this.notificationStatusesToClassNames = {
        'error': 'danger',
        'success': 'success',
        'info': 'info',
        'warning': 'warning'
    };

};

/**
 * Create a notification.
 *
 * @param status string
 * @param message string
 * @param timeout int
 */
Notifier.prototype.notify = function (status, message, timeout) {
    const notification = {
        status: status,
        message: message,
    };

    timeout = timeout || 5000;

    const notificationElement = this._createNotificationElement(notification);

    notification.timeoutId = setTimeout(() => {
        this._removeNotification(notificationElement);
        clearTimeout(notification.timeoutId);
    }, timeout);

    this._renderNotification(notificationElement);
};

/**
 * Render a notification
 *
 * @param notificationElement
 * @private
 */
Notifier.prototype._renderNotification = function (notificationElement) {
    this.notificationsList.appendChild(notificationElement);
};

/**
 * Remove a notification from the list.
 *
 * @param notificationElement
 * @private
 */
Notifier.prototype._removeNotification = function (notificationElement) {
    this.notificationsList.removeChild(notificationElement);
};

/**
 * Create a notification HTML element.
 *
 * @param notification
 * @returns {HTMLLIElement}
 * @private
 */
Notifier.prototype._createNotificationElement = function (notification) {
    let toast = document.createElement('div');
    toast.setAttribute('class', 'toast show animated bounceInRight');
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.setAttribute('aria-atomic', 'true');

    // Header
    let toastHeader = document.createElement('div');
    toastHeader.setAttribute('class', 'toast-header');
    toast.appendChild(toastHeader);

    let headerSquare = document.createElement('div');
    headerSquare.setAttribute('class', 'p-2 mr-2 rounded bg-' + this.notificationStatusesToClassNames[notification.status]);
    toastHeader.appendChild(headerSquare);

    let headerTitle = document.createElement('strong');
    headerTitle.setAttribute('class', 'mr-auto');
    headerTitle.appendChild(document.createTextNode('ClubAdminPro'));
    toastHeader.appendChild(headerTitle);

    // let headerTime = document.createElement('small');
    // headerTime.setAttribute('class', 'text-muted');
    // headerTime.appendChild(document.createTextNode('just now'));
    // toastHeader.appendChild(headerTime);

    // let closeButton = document.createElement('button');
    // closeButton.setAttribute('type', 'button');
    // closeButton.setAttribute('class', 'ml-2 mb-1 close');
    // closeButton.setAttribute('data-dismiss', 'toast');
    // closeButton.setAttribute('aria-label', 'Close');
    // toastHeader.appendChild(closeButton);
    //
    // let closeButtonCross = document.createElement('span');
    // closeButtonCross.appendChild(document.createTextNode('×'));
    // closeButton.appendChild(closeButtonCross);

    // Body.
    let toastBody = document.createElement('div');
    toastBody.setAttribute('class', 'toast-body');
    toastBody.appendChild(document.createTextNode(notification.message));
    toast.appendChild(toastBody);

    return toast;
};

const NotifierInstance = new Notifier();

module.exports = NotifierInstance;